<app-purchase-invoice-grid
    #purchaseInvoiceGridComponent
    [permissionKey]="'purchaseInvoices.list'"
    [filter]="['ThirdId.Id eq ' + element.Id]"
    (add)="onAddButtonClicked()"
    [canDelete]="true"
    [showPager]="false"
    [columns]="PurchaseInvoiceColumns"
></app-purchase-invoice-grid>